const Sponsorship = [
  {
    id: 1,
    title: "TITLE SPONSOR",
    price: "₹1 CR",
    description:
      "The ultimate partnership opportunity with maximum brand visibility and exclusive benefits.",
    features: [
      "80 VIP Access Passes",
      "Event Co-Branding",
      "Keynote Speaking Slot",
      "VIP Lounge Access",
      "Exclusive Media Coverage",
      "Private Networking Events",
    ],
    isHighlighted: false,
    buttonBg: "#FFC107",
    buttonTextColor: "#333333",
  },
  {
    id: 2,
    title: "ASSOCIATE SPONSOR",
    price: "₹50L",
    description:
      "Ideal for companies seeking significant brand exposure and engagement opportunities.",
    features: [
      "40 VIP Access Passes",
      "Premium Exhibition Space",
      "Speaking Opportunity",
      "Media Interview",
      "Branding on Event App",
      "Goodie Bag Inserts",
    ],
    isHighlighted: true,
    buttonBg: "#007BFF",
    buttonTextColor: "#FFFFFF",
  },
  {
    id: 3,
    title: "CO-SPONSOR",
    price: "₹20L",
    description:
      "Perfect for businesses looking to establish their presence at the summit.",
    features: [
      "25 VIP Access Passes",
      "Logo on Event Materials",
      "Standard Exhibition Stall",
      "Social Media Mentions",
    ],
    isHighlighted: false,
    buttonBg: "#E0E0E0",
    buttonTextColor: "#333333",
  },
  {
    id: 4,
    title: "EXHIBITION STALL DOUBLE",
    price: "₹10L",
    description:
      "Showcase your products and services directly to our audience of business leaders.",
    features: [
      "15 VIP Access Passes",
      "3 General Access Passes",
      "Standard Exhibition Space",
      "Listing in Event Directory",
      "Networking Opportunities",
    ],
    isHighlighted: false,
    buttonBg: "#E0E0E0",
    buttonTextColor: "#333333",
  },
  {
    id: 5,
    title: "EXHIBITION STALL SINGLE",
    price: "₹5L",
    description:
      "Showcase your products and services directly to our audience of business leaders.",
    features: [
      "10 VIP Access Passes",
      "Standard Exhibition Space",
      "Listing in Event Directory",
      "Networking Opportunities",
    ],
    isHighlighted: false,
    buttonBg: "#E0E0E0",
    buttonTextColor: "#333333",
  },
  {
    id: 6,
    title: "MAGAZINE",
    price: "₹1L",
    description:
      "Showcase your products and services directly to our audience of business leaders.",
    features: [
      "3 VIP Access Passes",
      "Cover page with Photograph",
      "500 -800 Word Content with Photo",
      "Company Logo",
      "Networking Opportunities",
    ],
    isHighlighted: false,
    buttonBg: "#E0E0E0",
    buttonTextColor: "#333333",
  },
];

export default Sponsorship;
